module.exports = __webpack_public_path__ + "img/man-otzS.13d653e4.svg";